const AuthLayout = ({ children }) => (
  <div className="auth-page">
    <div className="auth-page-header">
      <img src="/images/ruebarue-logo-full.svg" alt="RueBaRue" />
    </div>
    <div className="auth-page-body">{children}</div>
  </div>
);

export default AuthLayout;
